import React from "react";
import { Fuel, Clock, DollarSign } from "lucide-react";

export const Hero = () => {
  return (
    <section
      className="bg-hero-gradient text-white relative overflow-hidden"
      data-testid="hero-section"
    >
      {/* Decorative blobs */}
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#ecac1f]/10 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 -left-24 w-96 h-96 rounded-full bg-white/5 blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20 lg:py-24 relative">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <span className="gold-bar" />
            <span className="text-[#ecac1f] text-sm font-bold tracking-[0.18em] uppercase">
              We Keep You Moving
            </span>
          </div>

          <h1
            className="font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[1.05] mb-5"
            data-testid="hero-title"
          >
            Fuel Savings <br className="hidden sm:block" />
            <span className="text-[#ecac1f]">Calculator</span>
          </h1>

          <p
            className="text-base sm:text-lg text-white/85 max-w-2xl leading-relaxed"
            data-testid="hero-subtitle"
          >
            Discover how much your fleet can save with Ricochet Fuel&apos;s
            on-site fueling service. Enter a few details and we&apos;ll show
            you the annual labor savings, time savings, and per-vehicle
            payback in seconds.
          </p>

          {/* Stat strip */}
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4 max-w-2xl">
            {[
              {
                icon: DollarSign,
                label: "Labor Cost Saved",
                value: "$32/hr",
                testid: "hero-stat-labor",
              },
              {
                icon: Clock,
                label: "Saved Per Trip",
                value: "45 min",
                testid: "hero-stat-time",
              },
              {
                icon: Fuel,
                label: "Onsite Delivery",
                value: "24 / 7",
                testid: "hero-stat-delivery",
              },
            ].map(({ icon: Icon, label, value, testid }) => (
              <div
                key={label}
                className="flex items-center gap-3 bg-white/10 backdrop-blur-sm border border-white/15 rounded-xl px-4 py-3"
                data-testid={testid}
              >
                <div className="shrink-0 w-9 h-9 rounded-lg bg-[#ecac1f] text-[#2a1f4a] grid place-items-center">
                  <Icon className="w-4.5 h-4.5" strokeWidth={2.5} />
                </div>
                <div className="leading-tight">
                  <div className="font-display font-bold text-xl">{value}</div>
                  <div className="text-xs text-white/70 uppercase tracking-wider">
                    {label}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
